/**
 * OIDC SPA - adapter universal para Keycloak
 * Realm = realm de autenticação real (hostname), NÃO o subdomain simulado por impersonate.
 */
import { createOidc } from 'oidc-spa/core';
import { z } from 'zod';
import { getAuthRealm, persistAuthRealm } from '@/lib/subdomainPersistence';

const KEYCLOAK_URL = import.meta.env.VITE_KEYCLOAK_URL || 'http://localhost:8080';
const CLIENT_ID = 'spatuno-spa';

const getIssuerUri = () => {
  const realm = getAuthRealm();
  persistAuthRealm(realm);
  return `${KEYCLOAK_URL.replace(/\/+$/, '')}/realms/${realm}`;
};

/** Permite forçar logs de debug em testes via VITE_OIDC_DEBUG_LOGS=true|false */
const oidcDebugLogs = (): boolean => {
  const forced = import.meta.env.VITE_OIDC_DEBUG_LOGS;
  if (forced === "true") return true;
  if (forced === "false") return false;
  return Boolean(import.meta.env.DEV);
};

const issuerUri = getIssuerUri();
const prOidc = createOidc({
  issuerUri,
  clientId: CLIENT_ID,
  decodedIdTokenSchema: z.object({
    sub: z.string(),
    preferred_username: z.string().optional(),
    name: z.string().optional(),
    email: z.string().optional(),
    picture: z.string().optional(),
  }),
  debugLogs: oidcDebugLogs(),
});

export async function getOidc() {
  return prOidc;
}
